module["exports"] = [
  "Schweiz"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_CH/address/default_country.js
 ** module id = 382
 ** module chunks = 0
 **/